import React, { useEffect, useState } from "react";
import styled from "@emotion/styled/macro";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import arrow from "../../assets/images/arrow.svg";
import { withProps } from "recompose";
import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import close from "../../assets/images/close.svg";
import { ContentLayout } from "../../components/ui/ContentLayout";
import CmsService from "../../services/CmsService";
import ReactMarkdown from "react-markdown";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 4em;
  background: ${({ theme }) => theme.colors.aero};
  padding-top: 2em;
`;

const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
`;

const FAQWrapper = styled.div`
  padding-bottom: 4em;
`;

const StyledAccordionButton = styled(AccordionButton)`
  text-align: left;
  padding: 1em 0;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.secondary};
  justify-content: space-between;
  &:focus {
    box-shadow: none;
  }
`;
const StyledAccordionPanel = styled(AccordionPanel)`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.secondary};
  line-height: 1.5em;
  padding-left: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
`;
const StyledAccordionItem = styled(AccordionItem)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
  border-top: none;
  & a {
    text-decoration: underline;
  }
`;

const LearnMore = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 20em;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 2em 0 0;
  }
  border: 1px solid ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 0.35em 0;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Arrow = withProps({ src: arrow })(styled.img`
  margin: 0 0.5em;
`);
const Close = withProps({ src: close })(styled.img`
  margin: 0 0.5em;
`);
const FaqPart = ({ topic }) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [page, setPage] = useState();
  const { language } = i18n;

  useEffect(() => {
    const fetchPage = async () => {
      const api = new CmsService();
      setPage(null);
      try {
        const response = await api.getPageCollectionTypes(`faqs?populate[categories][populate][0]=questions`);
        setPage(response.categories);
      } catch (e) {
        console.log(e);
      }
    };
    fetchPage();
  }, [language]);
  const FAQ = page?.find((item) => item.name === topic);

  return (
    <Container>
      <ContentLayout>
        <Title>
          <ReactMarkdown children={FAQ?.name} />
        </Title>
        <FAQWrapper>
          <Accordion allowToggle>
            {FAQ?.questions.map((question) => (
              <StyledAccordionItem>
                {({ isExpanded }) => (
                  <>
                    <StyledAccordionButton>
                      <ReactMarkdown children={question.question} />
                      {isExpanded ? <Close /> : <Arrow />}
                    </StyledAccordionButton>
                    <StyledAccordionPanel>
                      <ReactMarkdown children={question.answer} />
                    </StyledAccordionPanel>
                  </>
                )}
              </StyledAccordionItem>
            ))}
          </Accordion>
        </FAQWrapper>
        <LearnMore as={Link} to={"/faq"}>
          {t("faq.button")}
        </LearnMore>
      </ContentLayout>
    </Container>
  );
};

export default FaqPart;
